import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { makeStyles } from 'utils/makeStylesAdapter';
import HelpIcon from '@mui/icons-material/Help';
import { toast } from 'react-toastify';
import { colors } from 'utils/colorsSteps';
import manualService from 'services/manual/manualService';
import { ModalSelectManualFile } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'transparent',
    color: colors.navBar,
    padding: theme.spacing(0.5),
    margin: theme.spacing(1),
    transition: 'transform 0.2s ease',
    '&:hover': {
      backgroundColor: 'transparent',
      transform: 'scale(1.1)',
    },
    '&.Mui-disabled': {
      opacity: 0.7,
    },
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0.3),
    },
  },
  icon: {
    color: 'inherit',
  },
}));

const ButtonManual = props => {
  const { screen, tooltip = 'Manual da tela', iconFontSize = 34, isPublic = false, ...rest } = props;

  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  const handleOpenManual = () => {
    if (loading) return;

    setLoading(true);

    const requestManualFiles = isPublic
      ? manualService.getPublicManualFilesByScreen(screen)
      : manualService.getManualFilesByScreen(screen);

    requestManualFiles
      .then(({ data }) => {
        const manualFiles = Array.isArray(data) ? data : [];

        if (manualFiles.length === 0) {
          toast.warn('Nenhum manual cadastrado para essa tela.');
          return;
        }

        if (manualFiles.length === 1) {
          window.open(manualFiles[0].url, '_blank');
          return;
        }

        setFiles(manualFiles);
        setOpenModal(true);
      })
      .catch(() => {
        toast.warn('Nenhum manual cadastrado para essa tela.');
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton
          {...rest}
          className={classes.root}
          onClick={handleOpenManual}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress color="inherit" size={iconFontSize - 8} />
          ) : (
            <HelpIcon className={classes.icon} style={{ fontSize: iconFontSize }} />
          )}
        </IconButton>
      </Tooltip>
      {openModal && (
        <ModalSelectManualFile
          open={openModal}
          onClose={() => setOpenModal(false)}
          files={files}
        />
      )}
    </>
  );
};

ButtonManual.propTypes = {
  screen: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  iconFontSize: PropTypes.number,
  isPublic: PropTypes.bool,
};

export default ButtonManual;
